import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetReminderGroupItemsDocument,
  ReminderGroupItemDataFragment,
} from '../../types/api/graphql';

export function useReminderGroupItems(
  healthProviderId: string | null | undefined
) {
  const { data: reminderGroupItemsData, loading: reminderGroupItemsLoading } =
    useCacheQuery(GetReminderGroupItemsDocument, {
      variables: {
        healthProviderId: healthProviderId ?? '',
      },
      skip: !healthProviderId,
    });

  const data = useMemo(
    () =>
      (reminderGroupItemsData?.reminderGroupNumbers ?? []).map(
        option => option as ReminderGroupItemDataFragment
      ),
    [reminderGroupItemsData?.reminderGroupNumbers]
  );

  return {
    data,
    loading: reminderGroupItemsLoading,
  };
}
